export const iconFontAwesomeHumanitarianTemperatureArrowUp = (
	<i className="fa-solid fa-temperature-arrow-up"></i>
);
